import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { SAVE_COMMAND } from './SavePlugin';

export const useSave = <T extends any[]>(
  fn: (markdown: string, ...args: T) => Promise<void>,
) => {
  const [editor] = useLexicalComposerContext();

  return useCallback(
    async (...args: T) => {
      // `dispatchCommand` invokes registered listeners (here, `SavePlugin`)
      // synchronously but discards their return value, so the promise
      // `fn` produces would otherwise be lost — callers would resolve as
      // soon as the command was dispatched rather than when the save
      // actually completed. Capture it via closure so it can be awaited
      // below; this relies on `SavePlugin`'s listener invoking (not just
      // scheduling) `saveCallback` before `dispatchCommand` returns.
      let savePromise: Promise<void> | undefined;
      const saveCallback = (markdown: string) => {
        savePromise = fn(markdown, ...args);
        return savePromise;
      };
      editor.dispatchCommand(SAVE_COMMAND, saveCallback);
      await savePromise;
    },
    [editor, fn],
  );
};
